export const UserMoveDestinationType = {
  ORGANISATION: 'organisation',
  TENANT: 'tenant',
  DOMAIN: 'domain'
} as const;

export type UserMoveDestinationType = (typeof UserMoveDestinationType)[keyof typeof UserMoveDestinationType];
